'use strict';

require('../../style/index.less');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/icon/style/index.js
// module id = 26
// module chunks = 0